import { Grid, Typography, Button, MenuItem, InputLabel, Link, Box, Dialog, DialogContent, DialogActions, DialogTitle } from '@material-ui/core'
import React, { useState } from 'react'
import { TextField, Select } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import OtpVerification from "./e_otp-verification";
import MuiLink from "@material-ui/core/Link";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { ticketService } from '../../model/_service';
import { Alert, Skeleton } from "@material-ui/lab";
import { CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const LinkComponent = withStyles({
  root: {
    "&[disabled]": {
      color: "grey",
      cursor: "default",
      "&:hover": {
        textDecoration: "none"
      }
    }
  }
})(MuiLink);

const OutlinedTextFiled = withStyles((theme) => ({
  root: {
    "& input::placeholder": {
      fontSize: "0.75rem !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0.62rem  !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "0.75rem !important",
    },
    "& .MuiInputBase-input:focus": {
      fontSize: "1rem !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base
    },
  },
}))(TextField);


const useStyles = makeStyles((theme) => ({
  errorMsgRightAlign: {
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
      marginRight: 0,
    }
  },
  dialogTitle: {
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
  },
  dialog:{
    position:"relative",
    zIndex:300 +"!important",
    "& .MuiDialog-paper": {
      [theme.breakpoints.up("sm")]: {
        minWidth: "400px"
      },
    }
  },
  textCenter: {
    textAlign: "center",
  },
  dialoagActionPadding: {
    paddingTop: "0.938rem",
    paddingBottom: "0.938rem",
  },
  verifyButton: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 15%",
    whiteSpace:"nowrap"
  },
  disableButton: {
    "& .Mui-disabled": {
      backgroundColor: theme?.palette?.eLight?.base,
      color: theme.palette.eWhite.base,
    }
  },
  circularLoading:{
    color : theme.palette.eWhite.base
  },
  alertStyle: {
    color: theme.palette.eDanger.dark,
    backgroundColor: theme.palette.eDanger.light,
  },
  verifyRightAlign: {
    justifyContent: "flex-end",
    "& .MuiLink-button": {
      color: theme.palette.ePrimary.base
    }
  },
  displayFlex: {
    display: "flex"
  },
  phoneInputPadding: {
    "& #registeredCell_Id": {
      padding: 7,
      borderRadius: 4,
      borderColor: "lightgrey !important",
      borderWidth: "thin",
    }
  },
  errorMsgRightAlignMobile: {
    marginLeft: 0,
    marginRight: 0,
    display: "flex",
    justifyContent: "flex-end"
  },
  userVerified: {
    color: theme.palette.eSecondary.base,
  },
  userVefiy: {
    whiteSpace: "nowrap",
  },
  verifyIcon: {
    fontSize: "small"
  },
  boxPaddingRight: {
    paddingRight: "1rem !important",
    [theme.breakpoints.down("xs")]: {
      paddingRight: "0 !important",
    },
  },
  verifyTopPadding: {
    paddingTop: "0.313rem"
  },
  asterisk: {
    color: theme.palette.eDanger?.dark
  },
  defaultColor: {
    color: theme?.palette?.eMedium?.base + "!important",
  },
  secondaryColor: {
    color: theme.palette.ePrimary.base + " !important",
    padding: 2,
    '& .MuiSvgIcon-root': {
      fontSize: 17,
    },
  },
  radioLabel: {
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  husbandRadio: {
    marginLeft: -2,
    marginRight: 5,
  },
  countryCodePadding: {
    paddingTop: "1vh !important"
  }
}))

function EApplicantDetails(props) {
  const {
    name,
    setName,
    fatherName,
    setFatherName,
    husbandName,
    setHusbandName,
    motherName,
    setMotherName,
    email,
    setEmail,
    openMobileDialog,
    setOpenMobileDialog,
    mobile,
    setMobile,
    nameRequire,
    setnameRequire,
    nameError,
    setnameError,
    fathernameRequire,
    fatherNameError,
    setfatherNameError,
    setfathernameRequire,
    husbandNameError,
    sethusbandNameError,
    motherNameError,
    setmotherNameError,
    emailRequire,
    setemailRequire,
    emailError,
    setemailError,
    mobileRequire,
    setmobileRequire,
    mobileError,
    setmobileError,
    isMobileVerified,
    setIsMobileVerified,
    individualMobileVerificationError,
    setindividualMobileVerificationError,
    husbandWifeRadio,
    sethusbandWifeRadio
     } = props;


  const classes = useStyles();
  const {t:content, ready: contentReady} = useTranslation("content-E_APPLICANT_DETAILS_SCREEN");
  const applicantLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS);
  const country_Calling_Code = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_PHONE_NUMBER_EXTENSION);
  const userNameLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.USERNAME_LENGTH);
  const mobileLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.MOBILE_LENGTH);
  const nameMinLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.NAME_MIN_LENGTH);
  const emailRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.EMAIL_REGEX);
  const landlineMaxLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_LANDLINE_MAX_LENGTH)
  const mobileRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_MOBILE_REGEX);
  const { t: applicantLabel, ready: applicantLabelReady } = useTranslation("label-E_APPLICANT_DETAILS");

  const [btnDisable, setBtnDisable] = useState(true);
  const [openOtpVerification, setOpenOtpVerification] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpMAxLimitError, setOtpMAxLimitError] = useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);


  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "mobile") {
      const re = RegExp(mobileRegex)
      if (value === "" || re.test(event.target.value)) {
        setMobile(value) 
        if (value.length == Number(mobileLength)) {
          setBtnDisable(false);
        } else {
          setBtnDisable(true);
        }
      }
    } else if (name === "name") {
      setName(value);
    } else if (name === "fatherName") {
      setFatherName(value);
    } else if (name === "husbandName") {
      setHusbandName(value);
    } else if (name === "motherName") {
      setMotherName(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "mobile") {
      setMobile(value);
    } else if (name === "husbandWifeRadio") {
      sethusbandWifeRadio(value);
    }
  };

  const nameBlur = () => {
    if (name) {
      setnameRequire(false);
      if (name.length >= Number(nameMinLength)) {
        setnameError(false);
      } else {
        setnameError(true);
      }
    } else {
      setnameRequire(true);
    }
  };

  const fatherNameBlur = () => {
    if (fatherName) {
      setfathernameRequire(false);
      if (fatherName.length >= Number(nameMinLength)) {
        setfatherNameError(false);
      } else {
        setfatherNameError(true);
      }
    } else {
      setfathernameRequire(true);
    }
  };

  const husbandNameBlur = () => {
    if (husbandName) {
      if (husbandName.length >= Number(nameMinLength)) {
        sethusbandNameError(false);
      } else {
        sethusbandNameError(true);
      }
    } else {
      sethusbandNameError(false);
    }
  };

  const motherNameBlur = () => {
    if (motherName) {
      if (motherName.length >= Number(nameMinLength)) {
        setmotherNameError(false);
      } else {
        setmotherNameError(true);
      }
    } else {
      setmotherNameError(false);
    }
  };

  const emailBlur = () => {
    if (email) {
      const emails = email.toLowerCase();
      setemailRequire(false);
      const emailRegEx = new RegExp("^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$");
      const test = emailRegEx.test(emails);
      if (test) {
        setemailError(false);
      } else {
        setemailError(true);
      }
    } else {
      setemailError(false);
    }
  };


  const mobileBlur = () => {
    if (mobile) {
      setmobileRequire(false);
      if (mobile.length == Number(mobileLength)) {
        setmobileError(false);
      } else {
        setmobileError(true);
      }
    } else {
      setmobileRequire(true);
    }
  };

  const handleVerifyClick = () => {
    if (mobile.length == Number(mobileLength)) {
      setLoading(true)
      ticketService.sendOtpMobile(mobile)
        .then((response) => {
          setLoading(false)
          setOpenOtpVerification(true);
          setOtpError(false);
          setOtpMAxLimitError(false);
        })
        .catch((error) => {
          setLoading(false)
          if (error.response.status === 403) {
            setOtpMAxLimitError(true);
            setOtpErrorMsg(error.response.data.message)
          }
          else {
            setOtpError(true);
          }
        });
    } else {
      mobileBlur()
    }
  }

  const handleClose = () => {
    setOpenMobileDialog(false);
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
              {
                applicantLabelReady ?
                  <Typography variant="caption">
                    {applicantLabel("E_APPLICANT_NAME")}<span className={classes.asterisk}>*</span>
                  </Typography>
                  : <Skeleton />
              }
              <OutlinedTextFiled
                variant="outlined"
                name="name"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={name}
                onChange={handleChange}
                onBlur={nameBlur}
                error={nameRequire || nameError}
                autoComplete="off"
                helperText={
                  nameRequire === true ? (
                    applicantLabelReady ? applicantLabel("E_APPLICANT_NAME") + applicantLabels?.E_APPLICANT_REQUIRED : ''
                  ) : nameError === true ? (
                    applicantLabels?.E_APPLICANT_ENTER_VALID_NAME
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_NAME_PLACEHOLDER") : ''}
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>

            <Grid item xs={12}>
              {
                applicantLabelReady ?
                  <Typography variant="caption">
                    {applicantLabel("E_APPLICANT_FATHERS_NAME")}<span className={classes.asterisk}>*</span>
                  </Typography>
                  : <Skeleton />
              }
              <OutlinedTextFiled
                variant="outlined"
                name="fatherName"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={fatherName}
                onChange={handleChange}
                onBlur={fatherNameBlur}
                error={fathernameRequire || fatherNameError}
                autoComplete="off"
                helperText={
                  fathernameRequire === true ? (
                    applicantLabelReady ? applicantLabel("E_APPLICANT_FATHERS_NAME") + applicantLabels?.E_APPLICANT_REQUIRED : ''
                  ) :
                  fatherNameError === true ? (
                    applicantLabels?.E_APPLICANT_ENTER_VALID_NAME
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_FATHERS_NAME_PLACEHOLDER") : ''}
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption">
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    row
                    name="husbandWifeRadio"
                    value={husbandWifeRadio}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="husband"
                      control={<Radio className={[classes.secondaryColor]} />}
                      label={<Typography variant="caption">
                        {applicantLabelReady ? applicantLabel("E_APPLICANT_HUSBAND_NAME") : ''}
                      </Typography>}
                      className={[classes.radioLabel, classes.husbandRadio]}
                    />
                    <FormControlLabel
                      value="wife"
                      control={<Radio className={[classes.secondaryColor]} />}
                      label={<Typography variant="caption">
                        {applicantLabelReady ? applicantLabel("E_APPLICANT_WIFE_NAME") : ''}
                      </Typography>}
                      className={classes.radioLabel}
                    />
                  </RadioGroup>
                </FormControl>
              </Typography>

              <OutlinedTextFiled
                variant="outlined"
                name="husbandName"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={husbandName}
                onChange={handleChange}
                onBlur={husbandNameBlur}
                error={husbandNameError}
                autoComplete="off"
                helperText={
                  husbandNameError === true ? (
                    applicantLabels?.E_APPLICANT_ENTER_VALID_NAME
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                placeholder={husbandWifeRadio == "husband" ? (applicantLabelReady ? applicantLabel("E_APPLICANT_HUSBANDS_NAME_PLACEHOLDER") : '') : (applicantLabelReady ? applicantLabel("E_APPLICANT_WIFES_NAME_PLACEHOLDER") : '')}
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>



          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
              <Grid container justify="space-between">
                <Grid item xs="auto">
                  <Typography variant="caption">
                    {applicantLabels?.E_APPLICANT_MOBILE_NUMBER}<span className={classes.asterisk}>*</span>
                  </Typography>
                </Grid>
                <Grid item xs="auto" className={[classes.verifyRightAlign, , (isMobileVerified !== true ? classes.displayFlex : classes.verifyTopPadding)]} >
                  {isMobileVerified !== true ? (<LinkComponent component="button"
                    onClick={setOpenMobileDialog(true)}
                    underline="always"
                  >
                    <Typography variant="caption">
                      <b>{applicantLabels?.E_APPLICANT_VERIFY}</b> {loading && <CircularProgress size={12} />}
                    </Typography>
                  </LinkComponent>) : (
                    <Grid container direction="row" alignItems="center" className={[classes.userVerified, classes.verifyRightAlign]}>
                      <CheckCircleIcon className={classes.verifyIcon} /> <Typography variant="caption" className={classes.userVefiy}>{`${applicantLabels?.E_APPLICANT_USER_VERIFIED}`} </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={2} className={classes.countryCodePadding}>
                  <Typography variant="caption">
                    {country_Calling_Code}
                  </Typography>

                </Grid>
                <Grid item xs={10}>
                  <OutlinedTextFiled
                    variant="outlined"
                    name="mobile"
                    fullWidth
                    inputProps={{
                      maxLength: Number(mobileLength),
                    }}
                    value={mobile}
                    disabled={isMobileVerified}
                    onChange={handleChange}
                    error={mobileRequire || mobileError || individualMobileVerificationError}
                    autoComplete="off"
                    helperText={
                      mobileRequire === true ? (
                        applicantLabels?.E_APPLICANT_MOBILE_NUMBER + applicantLabels?.E_APPLICANT_REQUIRED
                      ) : mobileError === true ? (
                        applicantLabels?.E_APPLICANT_MOBILE_NUMBER + applicantLabels?.E_APPLICANT_NOT_VALID
                      ) : (individualMobileVerificationError) ? (
                        applicantLabels?.E_APPLICANT_VERIFY_MOBILE
                      ) : (
                        <div>&nbsp;</div>
                      )
                    }
                    placeholder={applicantLabels?.E_APPLICANT_MOBILE_NUMBER_PLACEHOLDER}
                    className={[classes.errorMsgRightAlign]}
                  />
                </Grid>
              </Grid>
              {<OtpVerification
                individual={true}
                openOtpVerification={openOtpVerification}
                setOpenOtpVerification={setOpenOtpVerification}
                mobile={mobile}
                isMobileVerified={isMobileVerified}
                setIsMobileVerified={setIsMobileVerified}
                setMobileVerificationError={setindividualMobileVerificationError}
                 />}

              {(otpMAxLimitError || otpError) && (<Grid item xs={12}>
                {otpMAxLimitError && <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_MAX_OTP_ATTEMPTS_ERROR").answer?.replace("****", otpErrorMsg):""}</Alert>}
                {otpError && <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_OTP_TRY_AGAIN_ERROR").answer:""}</Alert>}
                <div>&nbsp;</div>
              </Grid>)}
            </Grid>

            <Grid item xs={12}>
              {
                applicantLabelReady ?
                  <Typography variant="caption">
                    {applicantLabel("E_APPLICANT_MOTHERS_NAME")}
                  </Typography>
                  : <Skeleton />
              }
              <OutlinedTextFiled
                variant="outlined"
                name="motherName"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={motherName}
                onChange={handleChange}
                onBlur={motherNameBlur}
                error={motherNameError}
                autoComplete="off"
                helperText={
                  motherNameError === true ? (
                    applicantLabels?.E_APPLICANT_ENTER_VALID_NAME
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_MOTHERS_NAME_PLACEHOLDER") : ''}
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption">
                {applicantLabels?.E_APPLICANT_EMAIL_ID}
              </Typography>
              <OutlinedTextFiled
                variant="outlined"
                name="email"
                fullWidth
                maxLength={Number(userNameLength)}
                value={email}
                onChange={handleChange}
                onBlur={emailBlur}
                error={emailError}
                autoComplete="off"
                helperText={ emailError === true ? (
                    applicantLabels?.E_APPLICANT_EMAIL_ID + applicantLabels?.E_APPLICANT_NOT_VALID
                  ) : (
                    <div>&nbsp;</div>
                  )
                }
                placeholder={applicantLabels?.E_APPLICANT_EMAIL_ID_PLACEHOLDER}
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Dialog onClose={handleClose} open={openMobileDialog} disableBackdropClick className={classes.dialog}>
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="subtitle1">
            {applicantLabelReady ? applicantLabel("E_APPLICANT_CUSTOMER_VERIFICATION") : ''}
          </Typography>
        </DialogTitle>
        <DialogContent dividers className={classes.textCenter}>
          {
            applicantLabelReady ?
              <Typography gutterBottom>
                {applicantLabel("E_APPLICANT_MOBILE_NUMBER_PLACEHOLDER")}<span className={classes.asterisk}>*</span>
              </Typography>
              : <Skeleton />
          }
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={2} className={classes.countryCodePadding}>
                <Typography variant="caption">
                  {country_Calling_Code}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <OutlinedTextFiled
                autoFocus
                  variant="outlined"
                  name="mobile"
                  fullWidth
                  inputProps={{
                    maxLength: Number(mobileLength),
                  }}
                  value={mobile}
                  onChange={handleChange}
                  error={mobileRequire || mobileError || individualMobileVerificationError}
                  autoComplete="off"
                  helperText={
                    mobileRequire === true ? (
                      applicantLabels?.E_APPLICANT_MOBILE_NUMBER + applicantLabels?.E_APPLICANT_REQUIRED
                    ) : mobileError === true ? (
                      applicantLabels?.E_APPLICANT_MOBILE_NUMBER + applicantLabels?.E_APPLICANT_NOT_VALID
                    ) : (individualMobileVerificationError) ? (
                      applicantLabels?.E_APPLICANT_VERIFY_MOBILE
                    ) : (
                      <div>&nbsp;</div>
                    )
                  }
                  placeholder={applicantLabels?.E_APPLICANT_MOBILE_NUMBER_PLACEHOLDER}
                  className={[classes.errorMsgRightAlign]}
                />
              </Grid>
            </Grid>
            {<OtpVerification
              individual={true}
              openOtpVerification={openOtpVerification}
              setOpenOtpVerification={setOpenOtpVerification}
              setOpenMobileDialog={setOpenMobileDialog}
              mobile={mobile}
              isMobileVerified={isMobileVerified}
              setIsMobileVerified={setIsMobileVerified}
              setMobileVerificationError={setindividualMobileVerificationError}
               />}

            {(otpMAxLimitError || otpError) && (<Grid item xs={12}>
              {otpMAxLimitError && <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_MAX_OTP_ATTEMPTS_ERROR").answer?.replace("****", otpErrorMsg) : ""}</Alert>}
              {otpError && <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_OTP_TRY_AGAIN_ERROR").answer : ""}</Alert>}
              <div>&nbsp;</div>
            </Grid>)}
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialoagActionPadding}>
          <Grid item xs={5} sm={4} md={4} className={classes.disableButton}>
            <Button
              className={classes.verifyButton}
              size="small"
              align="right"
              onClick={handleVerifyClick}
              disabled={btnDisable}
            >
              <Typography variant="button">{applicantLabelReady ? applicantLabel("E_APPLICANT_SEND_OTP") : <Skeleton />} { loading && <CircularProgress className={classes.circularLoading} size={12}/>}</Typography>
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}

export default EApplicantDetails